module.exports = __webpack_public_path__ + "img/uk-cancer-female.113beb32.png";